// Engine identity, carried by every result (docs/ENGINE-GUIDE.md). GPL-3.0-or-later.
export const ENGINE = { name: "@dipfield/wedge3d", version: "1.1.0" } as const;
